import { createSelector } from 'reselect'
import { getAlgoliaDataPaginationCurrent } from 'selectors/algolia2/data'
import { getUserId } from './app'
import { getFirstFacetValue, urlQuery } from '../helpers'
export { getAlgoliaUserToken } from 'selectors/user/cookie'
export const getAlgolia = (state: Record<string, any>): Record<string, any> => state?.algolia || {}
export const getAlgoliaData = createSelector(
  [getAlgolia],
  (algolia): Record<string, any> => algolia?.data || {}
)
export const getAgoliaPagination = createSelector(
  [getAlgoliaData],
  (data): Record<string, any> => data?.pagination || {}
)
export const getFriendlyPage = createSelector(
  [getAgoliaPagination],
  (page): number => page.current + 1 || 1
)
export const getAlgoliaDataHits = createSelector(
  getAlgoliaData,
  (data): Record<string, any> => data?.hits || {}
)
export const getAlgoliaDataHitsResults = createSelector(
  [getAlgoliaDataHits],
  (hits): Array<Record<string, any>> => hits.results || []
)
export const getHits = createSelector(
  getAlgoliaData,
  (algoliaResults): Record<string, any> => algoliaResults.hits || {}
)
export const getHitsResults = createSelector(
  getHits,
  (hits): Array<Record<string, any>> => hits.Results || []
)
export const getHitsPerPage = createSelector(getHits, (hits): number => hits.perPage || 25)
export const getHitsTotal = createSelector(getHits, (hits): number => hits.total || 0)
export const getAlgoliaQuery = createSelector(
  [getHitsPerPage, getAlgoliaDataPaginationCurrent],
  (hitsPerPage, page): Record<string, any> => ({
    ...(hitsPerPage !== 25
      ? {
          hitsPerPage,
        }
      : {}),
    ...(page !== 0
      ? {
          page: page + 1,
        }
      : {}),
  })
)
// Moved from Facets to here to avoid dependency cycle
export const getSelectedFacets = createSelector(
  getAlgolia,
  (algolia): Record<string, any> => algolia.selectedFacets || {}
)
// We want a list of all selected facets => [{ facetName: string, attributeName: string }, ...]
export const getSelectedFacetNameAttributes = (facetName: string) =>
  createSelector(
    getSelectedFacets,
    (selectedFacets): Array<string> => {
      const currentValues = selectedFacets[facetName] || []
      // We always want to work with an ARRAY to FILTER
      return Array.isArray(currentValues) ? currentValues : [currentValues]
    }
  )
export const getSlugifyDictionary = createSelector(
  getAlgolia,
  (algolia): Record<string, any> => algolia.slugifyDictionary || {}
)
export const getSelectedFacetNameFirstAttribute = (facetName: string) =>
  createSelector([getSelectedFacetNameAttributes(facetName)], (facetAttributes): string =>
    getFirstFacetValue(facetName, facetAttributes)
  )
export const getIsPubliclySearchableSelected = createSelector(
  [getSelectedFacetNameFirstAttribute('is_publicly_searchable')],
  (isPubliclySearchable): boolean => !!isPubliclySearchable
)
export const getUrlStringWithParams = (params: Record<string, any>) =>
  createSelector(
    [getUserId, getSelectedFacets, getAlgoliaQuery],
    (userId, selectedFacets, algoliaQuery): string => {
      // Removed facet from URL string at Product request
      const queryParams = { ...algoliaQuery, ...params }
      const queryString = urlQuery(queryParams)
      return `/account/collection/${userId}${queryString}`
    }
  )
export const getUrlStringWithoutParams = (params: Record<string, any>) =>
  createSelector(
    [getUserId, getSelectedFacets, getAlgoliaQuery],
    (userId, selectedFacets, algoliaQuery): string => {
      const queryParams = { ...params }
      const queryString = urlQuery(queryParams)
      return `/account/collection/${userId}${queryString}`
    }
  )